/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import type { PersonalizationParams } from '@/data/Content/RepurchaseCoupon';
import { createContext, useContext } from 'react';
import type { EmailCampaignsAddingProducts } from '@/data/Content/EmailCampaignsAddingProducts';

interface ServerSideRuntime {
	origin?: string;
	isMobile?: boolean;
	productJsonLd?: Record<string, unknown>;
	richSnippetJsonLd?: { emsName: string; data: Record<string, unknown> }[];
	emailCampaignsAddingProducts?: EmailCampaignsAddingProducts | null;
	personalization?: PersonalizationParams | null;
	mapApiKey?: string;
}

export const EMPTY_SERVER_SIDE_RUNTIME = {} as ServerSideRuntime;
export const ServerSideRuntimeContext = createContext<ServerSideRuntime>(EMPTY_SERVER_SIDE_RUNTIME);
export const ServerSideRuntimeProvider = ServerSideRuntimeContext.Provider;

export const useServerSideRuntime = () => {
	const runtime = useContext(ServerSideRuntimeContext);

	if (!runtime) {
		throw new Error('ServerSideRuntimeContext is not set');
	}

	return runtime;
};
